/**
 * @typedef {import('./lib/types.js').CharacterReferences} CharacterReferences
 * @typedef {import('./lib/types.js').Options} Options
 * @typedef {import('./lib/types.js').Quote} Quote
 * @typedef {import('./lib/types.js').Space} Space
 */

export {toHtml} from './lib/index.js'
